'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
import MobileFilterDrilldownWrapper from './MobileFilterDrilldownWrapper';

const MobileFilterNavItemWrapper = ({
  applyFilters,
  children,
  clickFilter,
  filterKey,
  onPanelClose,
  open,
  panelTitle,
  searchEnabled,
  textSection
}) => {
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    itemId: filterKey,
    onClickItem: clickFilter,
    title: textSection,
    children: /*#__PURE__*/_jsx(MobilePanel, {
      open: open,
      align: "right",
      children: /*#__PURE__*/_jsx(MobileFilterDrilldownWrapper, {
        title: panelTitle,
        onPanelClose: onPanelClose,
        applyFilters: applyFilters,
        searchEnabled: searchEnabled,
        children: children
      })
    })
  }, filterKey);
};

MobileFilterNavItemWrapper.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  clickFilter: PropTypes.func.isRequired,
  filterKey: PropTypes.string.isRequired,
  onPanelClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  panelTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  searchEnabled: PropTypes.bool,
  textSection: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
export default MobileFilterNavItemWrapper;